export const EVENT_TYPE_ONLINE = 'online';
export const EVENT_TYPE_OFFLINE = 'offline';
export const EVENT_TYPE_HYBRID = 'hybrid';

export const EVENT_PARTICIPATION_TYPES = ['online', 'offline'];

export const EVENT_TYPES_OPTIONS = [
    {
        type: EVENT_TYPE_ONLINE,
        nameRu: 'Онлайн',
        nameEn: 'Online',
    },
    {
        type: EVENT_TYPE_OFFLINE,
        nameRu: 'Офлайн',
        nameEn: 'Offline',
    },
    {
        type: EVENT_TYPE_HYBRID,
        nameRu: 'Онлайн и офлайн',
        nameEn: 'Online and offline',
    },
];

export const PAGE_TYPE_REGISTRATION = 'registration';

export const NOT_DELETABLE_PAGES = ['registration'];
export const INITIAL_PAGES_LIST = ['lobby', 'halls', 'broadcast', 'quiz', 'program', 'members', 'shop', 'profile'];

export const BLOCKS_PROPERTIES = {
    'hall-episodes': {
        titleEn: 'Schedule',
        titleRu: 'Расписание',
        showModal: true,
        showTitle: true,
        showInStreams: [],
    },
    'hall-description': {
        showModal: true,
        showInStreams: [],
        showBlockExpanded: true,
    },
    'legacy-banners': {
        showModal: true,
        display: {},
        showInStreams: [],
        showBlockExpanded: true,
    },
}
